import { useDelete, useGet, usePost } from '../../../sharedModules/hooks/useQuery';
import {
  AssignableUser,
  WarehouseDepartmentGroup,
  warehouseAssignableUsersUrl,
  warehouseDepartmentGroupsUrl,
} from '../model';

export function useWarehouseDepartmentGroups(location: string) {
  return useGet<WarehouseDepartmentGroup[]>({ url: warehouseDepartmentGroupsUrl, params: { location } });
}

export function useAddGroupMembership() {
  return usePost();
}

export function addGroupMembershipVariables(userId: number, groupId: string, location: string) {
  return { url: warehouseDepartmentGroupsUrl, data: { user_id: userId, group_id: groupId, location } };
}

export function useRemoveGroupMembership() {
  return useDelete();
}

export function removeGroupMembershipVariables(membershipId: number) {
  return { url: `${warehouseDepartmentGroupsUrl}/${membershipId}` };
}

export function useAssignableUsers() {
  return useGet<AssignableUser[]>({ url: warehouseAssignableUsersUrl });
}
